import React, { useContext, useEffect } from 'react';
import defaultStyles from './index.module.scss';
import SoyRappi from '../../../assets/soy-rappi-logo.png';
import TrashIcon from '../../../assets/filled-trash.svg';
import AcceptIcon from '../../../assets/accept.png';
import Avatar from '../../../assets/avatar.svg';
import Back from '../../../assets/arrow-back-black.svg';
import uploadIcon from '../../../assets/paper_upload.svg';
import { useNavigate } from 'react-router-dom';
import InputSimple from '../../atoms/input-simple';
import { perfilSatContext } from '../../../context/perfil.sat.context';
import Paper from '../../../assets/paper.svg';
import ModalSuccess from '../../molecules/modal-success';
import ModalError from '../../molecules/modal-error';

const UploadFiles: React.FC = () => {
  const browse = useNavigate();
  const {
    onFileChange,
    setSelectedFileCerCSD,
    setSelectedFileKeyCSD,
    inputPasswordCSD,
    setInputPasswordCSD,
    uploadSellosFiles,
    userProfile,
    selectedFileCerCSD,
    selectedFileKeyCSD,
    selectedFileKeyFiel,
    selectedFileCerFiel,
    setSelectedFileCerFiel,
    setSelectedFileKeyFiel,
    uploadFielFiles,
    inputPasswordFiel,
    setInputPasswordFiel,
    openSuccessModal,
    userToken,
    openErrorModal,
    errorFilesCode,
    setErrorFilesCode,
    requestCSD,
    requestFiel,
    successFielDocuments,
    successCsdDocuments
  } = useContext(perfilSatContext);

  const sendFilesSellos = async () => {
    if (userToken) {
      uploadSellosFiles();
    } else {
      browse('/login');
    }
  };

  const sendFilesFiel = () => {
    if (userToken) {
      uploadFielFiles();
    } else {
      browse('/login');
    }
  };

  const errorsValidation = () => {
    switch (errorFilesCode) {
      case 'E0001':
        return 'Error en la contraseña';
      case 'E0002':
        return 'El archivo .cer no es válido';
      case 'E0003':
        return 'El certificado ha expirado';
      case 'E0004':
        return 'El archivo .key no coincide con el archivo .cer';
      case 'E0005':
        return 'En vinculación de sellos, se están subiendo archivos que corresponden a fiel';
      case 'E0006':
        return 'En vinculación de fiel, se están subiendo archivos que corresponden a sellos digitales';
      case 'E0007':
        return 'El archivo .key no es válido';
    }
  };

  useEffect(() => {
    !userToken && browse('/login');
  }, []);

  return (
    <div className={defaultStyles.container}>
      {openSuccessModal && <ModalSuccess />}
      {openErrorModal && <ModalError />}
      <div className={defaultStyles.headerContainer}>
        <img
          src={SoyRappi}
          alt={'SoyRappi'}
          className={defaultStyles.logoPosition}
        />
        <div className={defaultStyles.avatarContainer}>
          <div className={defaultStyles.borderRight}></div>
          <img
            src={Avatar}
            alt={'Avatar'}
            style={{
              margin: '10px 0 0 10px'
            }}
          />
          <div className={defaultStyles.avatarName}>
            {userProfile.profile.first_name}
          </div>
        </div>
      </div>
      <div className={defaultStyles.border}></div>
      <div className={defaultStyles.fielContainer}>
        <div
          className={defaultStyles.backContainer}
          onClick={() => {
            browse('/home');
          }}
        >
          <img
            src={Back}
            alt={'Back'}
            style={{
              cursor: 'pointer',
              marginRight: '5px'
            }}
          />
          <div className={defaultStyles.backText}>Volver</div>
        </div>
        <div className={defaultStyles.documentsTitle}>Documentos fiscales</div>
        <div className={defaultStyles.documentsDescription}>
          Lee con detalle los campos, completa la información solicitada y sube
          los <br />
          documentos correspondientes.
        </div>
      </div>

      <div className={defaultStyles.fielContainer}>
        <div className={defaultStyles.documentSubtitle}>FIEL</div>
        <div
          className={defaultStyles.documentDetail}
          style={{
            color:
              errorFilesCode &&
              errorFilesCode !== 'E0001' &&
              requestFiel &&
              selectedFileKeyFiel
                ? 'red'
                : '#000000'
          }}
        >
          1. Clave del certificado FIEL (.key)
        </div>
        {selectedFileKeyFiel ? (
          <div className={defaultStyles.uploadFileContainer}>
            <div className={defaultStyles.flexContainer}>
              <div className={defaultStyles.filesNameContainer}>
                <img
                  src={Paper}
                  alt={'Paper'}
                  style={{ marginRight: '12px' }}
                />
                <div>
                  <div className={defaultStyles.fileName}>
                    {selectedFileKeyFiel.name}
                  </div>
                  <div className={defaultStyles.fileSize}>
                    {errorFilesCode === 'E0006' ||
                    errorFilesCode === 'E0007' ||
                    errorFilesCode === 'E0002' ||
                    errorFilesCode === 'E0005' ||
                    (errorFilesCode === 'E0004' && requestFiel) ? (
                      <div
                        className={defaultStyles.errorLabel}
                        style={{ left: '0' }}
                      >
                        {errorsValidation()}
                      </div>
                    ) : (
                      <>
                        {selectedFileCerCSD?.size} bytes -&nbsp;
                        <div className={defaultStyles.successFile}>
                          Archivo subido con éxito
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div>
                {successFielDocuments && (
                  <img
                    src={AcceptIcon}
                    width={'24'}
                    alt={'AcceptIcon'}
                    style={{ marginTop: '16px' }}
                  />
                )}
                {!successFielDocuments && (
                  <img
                    src={TrashIcon}
                    width={'24'}
                    alt={'TrashIcon'}
                    style={{
                      marginTop: '16px',
                      cursor: 'pointer',
                      marginLeft: '16px'
                    }}
                    onClick={() => {
                      setSelectedFileKeyFiel(null);
                      if (
                        errorFilesCode &&
                        (!['E0004', 'E0005', 'E0006'].includes(
                          errorFilesCode
                        ) ||
                          !selectedFileCerFiel)
                      ) {
                        setErrorFilesCode('');
                      }
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={defaultStyles.uploadContainer}>
              <img
                src={uploadIcon}
                alt={'uploadIcon'}
                style={{
                  margin: '0 auto',
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              />
              <div className={defaultStyles.uploadDescription}>
                Arrastra y suelta el archivo aquí o
              </div>
              <button className={defaultStyles.uploadButton}>
                <input
                  type='file'
                  id='fielFile'
                  accept='.key'
                  className={defaultStyles.inputFile}
                  onChange={(e: any) => onFileChange(e, setSelectedFileKeyFiel)}
                />
                Subir archivo
              </button>
            </div>
            <div className={defaultStyles.fileSpecification}>
              <div className={defaultStyles.filesDescription}>
                Formato permitido: .key
              </div>
              <div className={defaultStyles.filesDescription}>
                Tamaño máximo: 25 MB
              </div>
            </div>
          </>
        )}
        <div
          className={defaultStyles.documentDetail}
          style={{
            color:
              errorFilesCode &&
              errorFilesCode !== 'E0001' &&
              requestFiel &&
              selectedFileKeyFiel
                ? 'red'
                : '#000000'
          }}
        >
          2. Certificado de firma electrónica avanzada (.cer)
        </div>
        {selectedFileCerFiel ? (
          <div className={defaultStyles.uploadFileContainer}>
            <div className={defaultStyles.flexContainer}>
              <div className={defaultStyles.filesNameContainer}>
                <img
                  src={Paper}
                  alt={'Paper'}
                  style={{ marginRight: '12px' }}
                />
                <div>
                  <div className={defaultStyles.fileName}>
                    {selectedFileCerFiel.name}
                  </div>
                  <div className={defaultStyles.fileSize}>
                    {errorFilesCode === 'E0006' ||
                    errorFilesCode === 'E0002' ||
                    errorFilesCode === 'E0003' ||
                    errorFilesCode === 'E0005' ||
                    (errorFilesCode === 'E0004' && requestFiel) ? (
                      <div
                        className={defaultStyles.errorLabel}
                        style={{ left: '0' }}
                      >
                        {errorsValidation()}
                      </div>
                    ) : (
                      <>
                        {selectedFileCerCSD?.size} bytes -&nbsp;
                        <div className={defaultStyles.successFile}>
                          Archivo subido con éxito
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div>
                {successFielDocuments && (
                  <img
                    src={AcceptIcon}
                    width={'24'}
                    alt={'AcceptIcon'}
                    style={{ marginTop: '16px' }}
                  />
                )}
                {!successFielDocuments && (
                  <img
                    src={TrashIcon}
                    width={'24'}
                    alt={'TrashIcon'}
                    style={{
                      marginTop: '16px',
                      cursor: 'pointer',
                      marginLeft: '16px'
                    }}
                    onClick={() => {
                      setSelectedFileCerFiel(null);
                      if (
                        errorFilesCode &&
                        (!['E0004', 'E0005', 'E0006'].includes(
                          errorFilesCode
                        ) ||
                          !selectedFileKeyFiel)
                      ) {
                        setErrorFilesCode('');
                      }
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              className={defaultStyles.uploadContainer}
              style={{ marginTop: '35px' }}
            >
              <img
                src={uploadIcon}
                alt={'uploadIcon'}
                style={{
                  margin: '0 auto',
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              />
              <div className={defaultStyles.uploadDescription}>
                Arrastra y suelta el archivo aquí o
              </div>
              <button className={defaultStyles.uploadButton}>
                <input
                  type='file'
                  id='cerFile'
                  accept='.cer'
                  className={defaultStyles.inputFile}
                  onChange={(e: any) => onFileChange(e, setSelectedFileCerFiel)}
                />
                Subir archivo
              </button>
            </div>
            <div className={defaultStyles.fileSpecification}>
              <div className={defaultStyles.filesDescription}>
                Formato permitido: .cer
              </div>
              <div className={defaultStyles.filesDescription}>
                Tamaño máximo: 25 MB
              </div>
            </div>
          </>
        )}
        <div className={defaultStyles.passwordContainer}>
          <InputSimple
            isDisabled={successFielDocuments}
            inputValue={inputPasswordFiel}
            setInputValue={setInputPasswordFiel}
            placeholder={
              'Contraseña del certificado de firma electrónica avanzada (FIEL)'
            }
            staticStyle={defaultStyles}
            dynamicStyle={{
              borderColor:
                errorFilesCode === 'E0001' && requestFiel ? 'red' : ''
            }}
          />
        </div>
        {requestFiel && errorFilesCode === 'E0001' && (
          <div
            className={defaultStyles.errorLabel}
            style={{ marginTop: '30px' }}
          >
            {errorsValidation()}
          </div>
        )}
        <button
          className={defaultStyles.button}
          onClick={sendFilesFiel}
          disabled={
            (!inputPasswordFiel &&
              !selectedFileCerFiel &&
              !selectedFileKeyFiel) ||
            successFielDocuments
          }
        >
          Enviar
        </button>
      </div>

      <div className={defaultStyles.fielContainer}>
        <div className={defaultStyles.documentSubtitle}>Sellos - CSD</div>
        <div
          className={defaultStyles.documentDetail}
          style={{
            color:
              errorFilesCode &&
              errorFilesCode !== 'E0001' &&
              selectedFileKeyCSD &&
              requestCSD
                ? 'red'
                : '#000000'
          }}
        >
          1. Clave del certificado CSD (.key)
        </div>
        {selectedFileKeyCSD ? (
          <div className={defaultStyles.uploadFileContainer}>
            <div className={defaultStyles.flexContainer}>
              <div className={defaultStyles.filesNameContainer}>
                <img
                  src={Paper}
                  alt={'Paper'}
                  style={{ marginRight: '12px' }}
                />
                <div>
                  <div className={defaultStyles.fileName}>
                    {selectedFileKeyCSD?.name}
                  </div>
                  <div className={defaultStyles.fileSize}>
                    {errorFilesCode === 'E0007' ||
                    errorFilesCode === 'E0006' ||
                    errorFilesCode === 'E0005' ||
                    (errorFilesCode === 'E0004' && requestCSD) ? (
                      <div
                        className={defaultStyles.errorLabel}
                        style={{ left: '0' }}
                      >
                        {errorsValidation()}
                      </div>
                    ) : (
                      <>
                        {selectedFileKeyCSD?.size} bytes -&nbsp;
                        <div className={defaultStyles.successFile}>
                          Archivo subido con éxito
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div>
                {successCsdDocuments && (
                  <img
                    src={AcceptIcon}
                    width={'24'}
                    alt={'AcceptIcon'}
                    style={{ marginTop: '16px' }}
                  />
                )}
                {!successCsdDocuments && (
                  <img
                    src={TrashIcon}
                    width={'24'}
                    alt={'TrashIcon'}
                    style={{
                      marginTop: '16px',
                      marginLeft: '16px',
                      cursor: 'pointer',
                      color: '#354360'
                    }}
                    onClick={() => {
                      setSelectedFileKeyCSD(null);
                      if (
                        errorFilesCode &&
                        (!['E0004', 'E0005', 'E0006'].includes(
                          errorFilesCode
                        ) ||
                          !selectedFileCerCSD)
                      ) {
                        setErrorFilesCode('');
                      }
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={defaultStyles.uploadContainer}>
              <img
                src={uploadIcon}
                alt={'uploadIcon'}
                style={{
                  margin: '0 auto',
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              />
              <div className={defaultStyles.uploadDescription}>
                Arrastra y suelta el archivo aquí o
              </div>
              <button className={defaultStyles.uploadButton}>
                <input
                  type='file'
                  id='cerFile'
                  accept='.key'
                  className={defaultStyles.inputFile}
                  onChange={(e: any) => onFileChange(e, setSelectedFileKeyCSD)}
                />
                Subir archivo
              </button>
            </div>
            <div className={defaultStyles.fileSpecification}>
              <div className={defaultStyles.filesDescription}>
                Formato permitido: .key
              </div>
              <div className={defaultStyles.filesDescription}>
                Tamaño máximo: 25 MB
              </div>
            </div>
          </>
        )}
        <div
          className={defaultStyles.documentDetail}
          style={{
            color:
              errorFilesCode &&
              errorFilesCode !== 'E0001' &&
              selectedFileKeyCSD &&
              requestCSD
                ? 'red'
                : '#000000'
          }}
        >
          2. Certificado CSD (.cer)
        </div>
        {selectedFileCerCSD ? (
          <div className={defaultStyles.uploadFileContainer}>
            <div className={defaultStyles.flexContainer}>
              <div className={defaultStyles.filesNameContainer}>
                <img
                  src={Paper}
                  alt={'Paper'}
                  style={{ marginRight: '12px' }}
                />
                <div>
                  <div className={defaultStyles.fileName}>
                    {selectedFileCerCSD?.name}
                  </div>
                  <div className={defaultStyles.fileSize}>
                    {errorFilesCode === 'E0002' ||
                    errorFilesCode === 'E0005' ||
                    errorFilesCode === 'E0006' ||
                    errorFilesCode === 'E0003' ||
                    (errorFilesCode === 'E0004' && requestCSD) ? (
                      <div
                        className={defaultStyles.errorLabel}
                        style={{ left: '0' }}
                      >
                        {errorsValidation()}
                      </div>
                    ) : (
                      <>
                        {selectedFileCerCSD?.size} bytes -&nbsp;
                        <div className={defaultStyles.successFile}>
                          Archivo subido con éxito
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div>
                {successCsdDocuments && (
                  <img
                    src={AcceptIcon}
                    width={'24'}
                    alt={'AcceptIcon'}
                    style={{ marginTop: '16px' }}
                  />
                )}
                {!successCsdDocuments && (
                  <img
                    src={TrashIcon}
                    width={'24'}
                    alt={'TrashIcon'}
                    style={{
                      marginLeft: '16px',
                      marginTop: '16px',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setSelectedFileCerCSD(null);
                      if (
                        errorFilesCode &&
                        (!['E0004', 'E0005', 'E0006'].includes(
                          errorFilesCode
                        ) ||
                          !selectedFileKeyCSD)
                      ) {
                        setErrorFilesCode('');
                      }
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={defaultStyles.uploadContainer}>
              <img
                src={uploadIcon}
                alt={'uploadIcon'}
                style={{
                  margin: '0 auto',
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              />
              <div className={defaultStyles.uploadDescription}>
                Arrastra y suelta el archivo aquí o
              </div>
              <button className={defaultStyles.uploadButton}>
                <input
                  type='file'
                  id='cerFile'
                  accept='.cer'
                  className={defaultStyles.inputFile}
                  onChange={(e: any) => onFileChange(e, setSelectedFileCerCSD)}
                />
                Subir archivo
              </button>
            </div>
            <div className={defaultStyles.fileSpecification}>
              <div className={defaultStyles.filesDescription}>
                Formato permitido: .cer
              </div>
              <div className={defaultStyles.filesDescription}>
                Tamaño máximo: 25 MB
              </div>
            </div>
          </>
        )}
        <div className={defaultStyles.passwordContainer}>
          <InputSimple
            isDisabled={successCsdDocuments}
            inputValue={inputPasswordCSD}
            setInputValue={setInputPasswordCSD}
            placeholder={'Contraseña del certificado CSD'}
            staticStyle={defaultStyles}
            dynamicStyle={{
              borderColor: errorFilesCode === 'E0001' && requestCSD ? 'red' : ''
            }}
          />
        </div>
        {requestCSD && errorFilesCode === 'E0001' && (
          <div className={defaultStyles.errorLabel}>{errorsValidation()}</div>
        )}
        <button
          className={defaultStyles.button}
          onClick={sendFilesSellos}
          disabled={
            (!inputPasswordCSD && !selectedFileCerCSD && !selectedFileKeyCSD) ||
            successCsdDocuments
          }
        >
          Enviar
        </button>
      </div>
    </div>
  );
};

export default UploadFiles;
